import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Save form data to localStorage
    const existing = JSON.parse(localStorage.getItem('contactSubmissions')) || [];
    const updated = [...existing, formData];
    localStorage.setItem('contactSubmissions', JSON.stringify(updated));

    // Reset form and show success message
    setFormData({ name: '', email: '', message: '' });
    setSubmitted(true);

    // Hide message after 4 seconds
    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <section className="contact-section">
      <h2 className="contact-heading">Contact Us</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          value={formData.name}
          onChange={handleChange}
        />

        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          value={formData.email}
          onChange={handleChange}
        />

        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          required
          value={formData.message}
          onChange={handleChange}
        ></textarea>

        <button type="submit">Send Message</button>

        {submitted && <p className="contact-success">Thank you! We will contact you soon.</p>}
      </form>
    </section>
  );
};

export default Contact;
